import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-sso-redirect',
    templateUrl: './ssoRedirect.component.html',
    standalone: false
})
export class SSORedirectComponent implements OnInit {

  constructor() { }

  ngOnInit() :void{
  }

}
